import { render } from "./IcoBig.vue?vue&type=template&id=4dcef6f4"
import script from "./IcoBig.vue?vue&type=script&lang=js"
export * from "./IcoBig.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__